function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 15a1 1 0 001-1v-4a1 1 0 00-2 0v4a1 1 0 001 1zM7 15a1 1 0 001-1v-4a1 1 0 00-2 0v4a1 1 0 001 1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 4h-5V2.33A2.42 2.42 0 0011.5 0h-3A2.42 2.42 0 006 2.33V4H1a1 1 0 000 2h1v11a3 3 0 003 3h10a3 3 0 003-3V6h1a1 1 0 000-2zM8 2.33c0-.16.21-.33.5-.33h3c.29 0 .5.17.5.33V4H8zM16 17a1 1 0 01-1 1H5a1 1 0 01-1-1V6h12z"
});

function SvgIconTrashBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkViZW5lIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGQ9Ik0xMywxNWExLDEsMCwwLDAsMS0xVjEwYTEsMSwwLDAsMC0yLDB2NEExLDEsMCwwLDAsMTMsMTVaIi8+CiAgICA8cGF0aCBkPSJNNywxNWExLDEsMCwwLDAsMS0xVjEwYTEsMSwwLDAsMC0yLDB2NEExLDEsMCwwLDAsNywxNVoiLz4KICAgIDxwYXRoCiAgICAgICAgZD0iTTE5LDRIMTRWMi4zM0EyLjQyLDIuNDIsMCwwLDAsMTEuNSwwaC0zQTIuNDIsMi40MiwwLDAsMCw2LDIuMzNWNEgxQTEsMSwwLDAsMCwxLDZIMlYxN2EzLDMsMCwwLDAsMywzSDE1YTMsMywwLDAsMCwzLTNWNmgxYTEsMSwwLDAsMCwwLTJaTTgsMi4zM2MwLS4xNi4yMS0uMzMuNS0uMzNoM2MuMjksMCwuNS4xNy41LjMzVjRIOFpNMTYsMTdhMSwxLDAsMCwxLTEsMUg1YTEsMSwwLDAsMS0xLTFWNkgxNloiLz4KPC9zdmc+Cg==";
export { SvgIconTrashBin as ReactComponent };